<template>
<div>
    <div class="header-spacer"></div>
    <div style="width:100%; text-align:center;"><h1>Contact Us</h1></div>
    <div style="width:100%;">
        <form class="form" @submit="onSubmit" style="width:50%; margin: auto;">
            
            <label for="name" :class="{ invalid_label: result.errors.hasOwnProperty('name') }">Name *<span v-if="result.errors['name']"> -- {{ result.errors['name'][0] }}</span></label>
            <input type="text" required v-model="formData.name" :class="{ invalid_label: result.errors.hasOwnProperty('name') }" name='name' placeholder="Name" autocomplete="off">
            
            <label for="email" :class="{ invalid_label: result.errors.hasOwnProperty('email') }">Email *<span v-if="result.errors['email']"> -- {{ result.errors['email'][0] }}</span></label>
            <input type="email" required v-model="formData.email" :class="{ invalid_label: result.errors.hasOwnProperty('email') }" name='email' placeholder="Email">
            
            <label for="subject" :class="{ invalid_label: result.errors.hasOwnProperty('subject') }">Subject *<span v-if="result.errors['subject']"> -- {{ result.errors['subject'][0] }}</span></label>
            <input type="text" required v-model="formData.subject" :class="{ invalid_label: result.errors.hasOwnProperty('subject') }" name='subject' placeholder="Subject">
            
            <label for="message" :class="{ invalid_label: result.errors.hasOwnProperty('message') }">Message *<span v-if="result.errors['message']"> -- {{ result.errors['message'][0] }}</span></label>
            <textarea name="message" rows="5" v-model="formData.message" :class="{ invalid_label: result.errors.hasOwnProperty('message') }" placeholder="Message"></textarea>
            
            <vue-recaptcha ref="recaptcha" sitekey="6LemX98UAAAAAIG2tbCaZr8K0mU0shNYfGkOodyA" size="normal" :loadRecaptchaScript="true" @verify="onCaptchaVerified" @expired="onCaptchaExpired">
                <button type="submit" style="width:100%;" :disabled="isSending">Send</button>
            </vue-recaptcha>
        </form>
        <div class="form-message" v-bind:class="{ active: result.message }">
            <p v-if="result.message">{{ result.message }} <span v-for="item in result.errors" :key="item[0]"> {{ item[0] }}</span></p>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
// import Page from '../views/Page.vue'
export default{
    name: 'contactform',
    data() {
        return {
            formData: {
                name: '',
                email: '',
                subject: '',
                message: '',
                recaptchaToken: '',
            },
            result: {
                success: null,
                message: null,
                errors: {},
            },
            isSending: false,
        }    
    },
    components: {
        VueRecaptcha
    },
    methods:{
        clearForm() {
            for (let field in this.formData) {
                this.formData[field] = '';
            }
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.isSending = true;
            this.result.success = null;
            this.result.message = null;
            this.result.errors = {};
            let csrftoken = this.getCookie('csrftoken');
            let headers = {
                'X-CSRFToken': csrftoken,
                'credentials': 'include',
            }
            setTimeout(() => {
                let form = new FormData();
                for (let field in this.formData) {
                    form.append(field, this.formData[field])
                }
                let vueObj = this;
                axios.post('/api/contact_form/', form, {headers: headers}).then((response) => {
                    console.log(response);
                    this.result['success'] = response.data.success;
                    this.result['message'] = response.data.message;
                    if (response.data.errors) {
                        this.result.errors = response.data.errors;
                    }
                    if (response.data.success) {
                        this.clearForm();
                    }
                }).catch((e) => {
                    console.log(e);
                    this.result['success'] = false;
                    this.result['message'] = "There was an error sending your message."
                }).then(function () {
                    vueObj.$refs.recaptcha.reset();
                    vueObj.isSending = false;
                })
            }, 1000);
        },
        getCookie(name) {
            var cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        onCaptchaVerified(recaptchaToken) {
            // console.log("This is the token in question:")
            // console.log(recaptchaToken)
            this.formData.recaptchaToken = recaptchaToken;
        },
        onCaptchaExpired() {
            this.formData.recaptchaToken = '';
        }
    },
}
</script>

<style scoped>
.header-spacer {
    height: 75px;
    background: #333;
}
h1 {
    font-size: 4rem;
    color: #114872;
}

.form-wrap{
    padding-top: 12.25rem;
    padding-bottom: 4rem;
    background: #e8e8e8;
    /* height: 100%; */
}

label, legend{
    color: #114872;
    font-weight: 600;
}

.form-message{
    padding: 2rem 2rem;
    background:transparent;
    border-radius: 1rem;
}

.form-message.active {
     background: #f9e02c;
}

.form-message p {
    margin-bottom: 0;
}

.form-wrap form, .form-info, .form-message{
    width: 60%;
    min-width: 600px;
    margin: 0 auto;
}

.invalid_label {
    color: red;
}

.invalid_field {
    border-color: red;
}

input{
    font-size: 1.5rem;
    color: #333333;
}

input, select{
    height: 5rem;
    border: .1rem solid#d0d0d0;

}

input, select, button{
    border-radius: 1rem;
}

button{
    margin-top: 1.25rem;
}

::placeholder {
    color: #adadad;
}

@media (max-width: 769px){
    .form-wrap form, .form-info, .form-message{
        width: 90%;
        min-width: auto;
    }

}

</style>